export const MENU_HEIGHT = 56;
export const MOBILE_MENU_HEIGHT = 44;
export const TOP_BANNER_HEIGHT = 70;
export const TOP_BANNER_HEIGHT_MOBILE = 44; // one-line phishing warning on phones (site review 59 #2; was 84, two lines)
